import Hero from "../components/home/Hero";
import ServicesOverview from "../components/home/ServicesOverview";
import StatsBar from "../components/home/StatsBar";
import ProcessSection from "../components/home/ProcessSection";
import TechStack from "../components/home/TechStack";
import IndustriesSection from "../components/home/IndustriesSection";
import FeaturedWork from "../components/home/FeaturedWork";
import Testimonials from "../components/home/Testimonials";
import HomeCTA from "../components/home/HomeCTA";
import SEOHead from "../components/SEOHead";
import WaveDivider from "../components/graphics/WaveDivider";
import InfiniteMarquee from "../components/motion/InfiniteMarquee";

const techItems = [
  "React", "TypeScript", "Next.js", "Node.js", "Python", "AWS",
  "Docker", "Kubernetes", "PostgreSQL", "MongoDB", "Redis",
  "TensorFlow", "LangChain", "OpenAI", "Shopify", "Figma",
];

const Index = () => (
  <>
    <SEOHead
      title="Obsidian Web Labs | Enterprise AI, Software & Web Solutions"
      description="Headquartered in Delhi, India. OWL delivers enterprise software, AI, and digital solutions for global businesses."
      canonicalUrl="https://www.obsidianweblabs.com/"
      schema={{
        "@context": "https://schema.org",
        "@type": "Organization",
        name: "Obsidian Web Labs",
        url: "https://www.obsidianweblabs.com",
        logo: "https://www.obsidianweblabs.com/owl-mark.svg",
        contactPoint: {
          "@type": "ContactPoint",
          contactType: "customer support",
          telephone: "+916393387138",
        },
        address: {
          "@type": "PostalAddress",
          addressLocality: "New Delhi",
          addressRegion: "Delhi",
          addressCountry: "IN",
        },
      }}
    />
    <Hero />
    <WaveDivider variant="liquid" dark />

    {/* Trust marquee */}
    <div style={{ background: "#050505", paddingTop: 20, paddingBottom: 20 }}>
      <InfiniteMarquee speed={35}>
        {techItems.map((t) => (
          <span
            key={t}
            style={{
              fontFamily: "'Barlow Condensed', sans-serif",
              fontWeight: 300,
              fontSize: 14,
              letterSpacing: "0.2em",
              textTransform: "uppercase",
              color: "#908A83",
              whiteSpace: "nowrap",
            }}
          >
            {t} <span style={{ color: "#D4A843", margin: "0 8px" }}>◆</span>
          </span>
        ))}
      </InfiniteMarquee>
      <div style={{ marginTop: 8 }}>
        <InfiniteMarquee speed={40} reverse>
          {techItems.reverse().map((t) => (
            <span
              key={t}
              style={{
                fontFamily: "'Barlow Condensed', sans-serif",
                fontWeight: 300,
                fontSize: 14,
                letterSpacing: "0.2em",
                textTransform: "uppercase",
                color: "#908A83",
                whiteSpace: "nowrap",
              }}
            >
              {t} <span style={{ color: "#D4A843", margin: "0 8px" }}>◆</span>
            </span>
          ))}
        </InfiniteMarquee>
      </div>
    </div>

    <WaveDivider variant="fracture" />
    <ServicesOverview />
    <WaveDivider variant="circuit" />
    <StatsBar />
    <WaveDivider variant="diagonal" />
    <ProcessSection />
    <WaveDivider variant="liquid" />
    <TechStack />
    <WaveDivider variant="fracture" />
    <IndustriesSection />
    <WaveDivider variant="circuit" />
    <FeaturedWork />
    <WaveDivider variant="diagonal" dark />
    <Testimonials />
    <WaveDivider variant="liquid" dark />
    <HomeCTA />
  </>
);

export default Index;
